import type { Dispatch, SetStateAction } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { EditorState } from "../connectorManagerHelpers";

export const GhostFields = ({
  editor,
  setEditor,
}: {
  editor: EditorState;
  setEditor: Dispatch<SetStateAction<EditorState>>;
}) => (
  <div className="space-y-3">
    <div className="space-y-2">
      <Label htmlFor="connector-ghost-url">Ghost admin URL</Label>
      <Input
        id="connector-ghost-url"
        type="url"
        value={editor.ghostAdminUrl}
        onChange={(e) => setEditor((s) => ({ ...s, ghostAdminUrl: e.target.value }))}
        placeholder="https://yourblog.ghost.io"
      />
      <p className="text-xs text-muted-foreground">
        The base URL of your Ghost site. Works for Ghost(Pro) and self-hosted Ghost.
        Don&apos;t include <code>/ghost</code> — we add the admin API path automatically.
      </p>
    </div>
    <div className="space-y-2">
      <Label htmlFor="connector-ghost-key">
        Admin API key {editor.connector ? "(leave blank to keep)" : ""}
      </Label>
      <Input
        id="connector-ghost-key"
        type="password"
        autoComplete="new-password"
        value={editor.secretValue}
        onChange={(e) => setEditor((s) => ({ ...s, secretValue: e.target.value }))}
        placeholder="abc123…:def456…  (id:secret)"
      />
    </div>
    <div className="rounded-md border border-dashed border-border bg-muted/30 p-3 text-xs text-muted-foreground">
      <p className="mb-1 font-medium text-foreground">How to get an Admin API key</p>
      <ol className="list-decimal space-y-0.5 pl-4">
        <li>
          In Ghost admin, go to <strong>Settings → Advanced → Integrations</strong>.
        </li>
        <li>
          Click <strong>Add custom integration</strong>, name it <em>Excerptus</em>.
        </li>
        <li>
          Copy the <strong>Admin API Key</strong> (format <code>id:secret</code>) and paste it above.
        </li>
      </ol>
      <p className="mt-2">
        Posts are created as drafts so you can review and publish from Ghost admin. Use{" "}
        <strong>Test</strong> after saving to verify the credentials.
      </p>
    </div>
  </div>
);
